<a class="sc-skip-link sc-button" href="#main-content">Skip to content</a>
<app-main-header [signedIn]="!!session.account()" />
<main id="main-content" tabindex="-1"><router-outlet /></main>
<footer class="sc-container footer sc-small sc-muted">
  <div class="footer-brand">
    <strong>Square Control</strong>
    <span>More time for chess.</span>
  </div>
  <nav class="footer-nav" aria-label="Footer navigation">
    <a routerLink="/players-and-parents">Players &amp; parents</a>
    <a routerLink="/club-owners-and-teachers">Club owners &amp; teachers</a>
    <a routerLink="/clubs">Find a club</a>
  </nav>
</footer>
